// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"Statistics_searchForm__vxrDD"};